import { useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import AppContext from '../AppContext';
import { ResendInvitationInput, ResendInvitationPayload } from './generated/types';

export const useResendInvitation = () => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: ResendInvitationInput) => {

            const mutation = `mutation ResendInvitation($input: ResendInvitationInput! ) {
              resendInvitation(input: $input) {
                id
              }
            }`;

            await (context.api.graphql({ query: mutation, variables: { input } }) as Promise<{
                data: {
                    resendInvitation: ResendInvitationPayload;
                };
            }>);

            return true;
        },
        onSuccess: (data, variables) => {
            if (data) {
                void queryClient.invalidateQueries({ queryKey: ['getOrganization', variables.orgId] });
            }
        },
    },
    );
};
